import { FC, ImgHTMLAttributes } from 'react';
import { useIntl } from 'dibs-react-intl';
import { isLocale, LOCALE_US } from 'dibs-intl/exports/locales';
import { handleLocalizedImageUrl } from 'dibs-intl/exports/urls';

type Props = Omit<
    ImgHTMLAttributes<HTMLImageElement> & {
        alt: string;
        src: string;
        dataTn?: string;
    },
    'srcSet' // source sets are not supported
>;

export const LocalizedImage: FC<Props> = props => {
    const { src, alt, dataTn, ...passThroughProps } = props;
    const intl = useIntl();
    const localizedSrc = handleLocalizedImageUrl(
        src,
        isLocale(intl?.locale) ? intl?.locale : LOCALE_US
    );
    const fallbackSrc = handleLocalizedImageUrl(src, LOCALE_US);
    return (
        <img
            {...passThroughProps}
            alt={alt}
            src={localizedSrc}
            data-tn={dataTn}
            onError={e => {
                if (e.currentTarget.src !== src) {
                    e.currentTarget.src = fallbackSrc;
                }
            }}
        />
    );
};
